import { render, staticRenderFns } from "./new-trend.vue?vue&type=template&id=620c4c51&scoped=true&"
import script from "./new-trend.vue?vue&type=script&lang=js&"
export * from "./new-trend.vue?vue&type=script&lang=js&"
import style0 from "./new-trend.vue?vue&type=style&index=0&id=620c4c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c4c51",
  null
  
)

export default component.exports